import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\">\n<path d=\"M8.375 8.375V1.5C8.375 1.3175 8.43354 1.16771 8.55062 1.05062C8.66771 0.933542 8.8175 0.875 9 0.875C9.1825 0.875 9.33229 0.933542 9.44938 1.05062C9.56646 1.16771 9.625 1.3175 9.625 1.5V8.375H16.5C16.6825 8.375 16.8323 8.43354 16.9494 8.55062C17.0665 8.66771 17.125 8.8175 17.125 9C17.125 9.1825 17.0665 9.33229 16.9494 9.44938C16.8323 9.56646 16.6825 9.625 16.5 9.625H9.625V16.5C9.625 16.6825 9.56646 16.8323 9.44938 16.9494C9.33229 17.0665 9.1825 17.125 9 17.125C8.8175 17.125 8.66771 17.0665 8.55062 16.9494C8.43354 16.8323 8.375 16.6825 8.375 16.5V9.625H1.5C1.3175 9.625 1.16771 9.56646 1.05062 9.44938C0.933542 9.33229 0.875 9.1825 0.875 9C0.875 8.8175 0.933542 8.66771 1.05062 8.55062C1.16771 8.43354 1.3175 8.375 1.5 8.375H8.375Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/plus.svg
// module id = gD1+
// module chunks = 262